// extracted by extract-css-chunks-webpack-plugin
module.exports = {"textarea":"_3jT-nA","default":"UcyKjA","fullWidth":"_24tiR0","noResize":"_2o-wgl"};